import { FC } from "react";
import { TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import TableData from "../../../../../../../../components/common/table/TableData";
import { EntityItemDTO } from "../../../../../../../../datasources/api-client/data-contracts";
import { mapDataColumns, mapDataRows } from "../../../../../../../../utilities/dataGridUtilities";

interface Props {
	entities: EntityItemDTO[];
}

export const ArcEntities: FC<Props> = ({ entities }) => {
	const { t } = useTranslation("feature.results");
	const theme = useTheme();

	if (entities.length <= 0) {
		return <></>;
	}

	const rows = mapDataRows<EntityItemDTO>({ items: entities }, "id");
	const columns = mapDataColumns<EntityItemDTO>({ items: entities }, t, theme, [
		{ field: "description", headerName: "description", renderAs: "text" },
		{ field: "originDescription", headerName: "departure", renderAs: "text" },
		{ field: "destinationDescription", headerName: "arrival", renderAs: "text" },
		{ field: "distance", headerName: "distance", renderAs: "measure" },
		{ field: "weight", headerName: "weight", renderAs: "measure" },
		{ field: "emissionWtw", headerName: "emissions wtw", renderAs: "measure" },
		{ field: "emissionTtw", headerName: "emissions ttw", renderAs: "measure" },
	]);

	return (
		<TimelineItem>
			<TimelineSeparator>
				<TimelineConnector />
			</TimelineSeparator>
			<TimelineContent
				position="relative"
				left="0"
				padding="0 !important"
				sx={{
					marginLeft: "64px !important",
					marginBottom: 2,
					overflowX: "auto",
				}}
			>
				<TableData
					title={t("tripDetails/arc entities")}
					columns={columns}
					rows={rows}
					isPrimaryColor={true}
					isLoading={false}
				/>
			</TimelineContent>
		</TimelineItem>
	);
};
